module.exports = __webpack_public_path__ + "static/media/s1.c196227b.svg";